
export const activitySchema = {
  // "kind": "",
  assignedTo: null, // nuevo
  name: "",
  details: "",
  status: "pending",
  party: [
    // 123",
    // {
    //   "id": 1,
    //   "from": "system"
    // }

  ],
  todos: [
    // "Tarea 1",
    // {
    //   "name": "Todo 1",
    //   "completed": true
    // },
  ],
  resources: [
    // {
    //   "type": "",
    //   "resource": "",
    //   "details": "",
    // },
  ],
  // created_at: new Date(),
  deadline: "",
  timeDeadline: "",
}

export const todoSchema = {
  assignedTo: null, // { id: 1, from: "system" }
  name: "",
  details: "",
  completed: false,
  deadline: "",
  timeDeadline: "",
  dedicatedHours: "",
  // party: [],
}

export const resourceSchema = {
  assignedTo: null, // { id: 1, from: "system" }
  name: "",
  details: "",
  completed: false,
  deadline: "",
  timeDeadline: "",
  dedicatedHours: "",
}
